import TopTicker from '@/pages/home/components/TopTicker';
import Navbar from '@/pages/home/components/Navbar';

export default function SiteHeader() {
  return (
    <header id="top" className="sticky top-0 z-50">
      <TopTicker />
      <Navbar />
    </header>
  );
}